import { useQuery } from '@tanstack/react-query';
import { getZone } from '@/api/zone';
import { ZoneFilters } from '@/api/zone/types';

export function useZones(filters: ZoneFilters, zone_id: string) {
  return useQuery({
    queryKey: ['zones', filters, zone_id],
    queryFn: () => getZone(filters, zone_id),
    staleTime: 30000, // Consider data fresh for 30 seconds
    enabled: !!zone_id, // Only fetch when `data` is available
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}